import { handleActions, combineActions } from 'redux-actions';
import * as actions from '../actions/adSlotActions';

const defaultState = {
  current: {
    items: [],
  },
  slots: [],
  items: [],
  itemOptions: [],
  showModal: false,
  count: 0,
  pages: 0,
  activePage: 1,
  query: {
    firmId: '',
    site: '',
    status: undefined,
  },
};

const reducer = handleActions(
  {
    [combineActions(actions.getAdSlotsSuccess, actions.searchAdSlotsSuccess)]: (
      state,
      { payload: { slots, count } }
    ) => {
      return { ...state, slots, count: Math.ceil(count / 20) };
    },
    [actions.showAdSlotModal]: state => {
      return { ...state, showModal: true };
    },
    [actions.updatePage]: (state, { payload: { activePage } }) => {
      return { ...state, activePage };
    },
    [actions.updateQuery]: (state, { payload: { query } }) => {
      return { ...state, query };
    },
    [actions.hideAdSlotModal]: state => {
      return { ...state, showModal: false };
    },
    [actions.getItemsForFirmsSuccess]: (state, { payload: { items } }) => {
      return {
        ...state,
        showModal: false,
        items: items.reduce((prev, curr) => {
          prev[curr.id] = curr;
          return prev;
        }, {}),
      };
    },
    [combineActions(
      actions.setCurrentAdSlot,
      actions.updateAdSlotSuccess,
      actions.getAdSlotByIdSuccess,
      actions.updateCurrentAdSlotItemsSuccess
    )]: (state, { payload: { slot } }) => {
      return { ...state, current: slot };
    },
  },
  defaultState
);

export default reducer;
